import { useEffect, useState } from 'react';
import { ref, getDownloadURL } from 'firebase/storage';
import { FileText } from 'lucide-react';
import { storage } from '../../../shared/lib/firebase';
import { Avatar } from '../../../shared/ui/Avatar';
import { Badge } from '../../../shared/ui/Badge';
import { timeAgo } from '../../../shared/utils/timeAgo';
import type { SupportMessage } from '../lib/types';
import styles from '../SupportTicketView.module.css';

export function TicketMessageBubble({ message, mine }: { message: SupportMessage; mine: boolean }) {
  const [urls, setUrls] = useState<Record<string, string>>({});
  useEffect(() => {
    let aborted = false;
    // Cada anexo se resolve sozinho: um que falha não esconde os outros.
    Promise.all(
      message.attachments.map((a) =>
        getDownloadURL(ref(storage, a.path)).then(
          (u) => [a.path, u] as const,
          (e) => { console.error('[ticket attachment url]', e); return [a.path, ''] as const; },
        ),
      ),
    ).then((pairs) => { if (!aborted) setUrls(Object.fromEntries(pairs)); });
    return () => { aborted = true; };
  }, [message.attachments]);

  const isAdmin = message.authorRole === 'admin';

  return (
    <div className={`${styles.bubbleRow} ${mine ? styles.mine : styles.theirs}`}>
      <Avatar name={message.authorName} size="sm" />
      <div className={styles.bubbleWrap}>
        <div className={styles.bubbleHead}>
          <span className={styles.bubbleAuthor}>{message.authorName}</span>
          {isAdmin ? <Badge tone="primary">Suporte</Badge> : null}
          <span className={styles.bubbleTime}>{timeAgo(message.createdAt?.toMillis())}</span>
        </div>
        <div className={styles.bubble}>
          {message.body ? <div className={styles.bubbleBody}>{message.body}</div> : null}
          {message.attachments.length > 0 ? (
            <div className={styles.attachments}>
              {message.attachments.map((a) =>
                urls[a.path] ? (
                  a.contentType.startsWith('image/') ? (
                    <a key={a.path} href={urls[a.path]} target="_blank" rel="noreferrer" className={styles.attachmentImg}>
                      <img src={urls[a.path]} alt={a.name} className={styles.attachmentThumb} />
                    </a>
                  ) : (
                    <a key={a.path} href={urls[a.path]} target="_blank" rel="noreferrer" className={styles.attachmentLink}>
                      <FileText size={14} aria-hidden /> {a.name}
                    </a>
                  )
                ) : a.path in urls ? (
                  <span key={a.path} className={styles.attachmentLoading}>Não foi possível abrir o anexo</span>
                ) : (
                  <span key={a.path} className={styles.attachmentLoading}>{a.name}…</span>
                ),
              )}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
